import $ from '../$';
import each from '../functions/each';
import dir from './utils/dir';
each(['', 'All', 'Until'], (nameIndex, name) => {
  $.fn[`next${name}`] = function (selector, filter) {
    return dir(this, nameIndex, 'nextElementSibling', selector, filter);
  };
});